<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <span class="w-title">{{ adding?`新建${pageName}`:(editing ? `修改${pageName}` : `${pageName}详情`) }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回{{ pageName }}列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="(!adding) && hideWhenNotUser" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing && hideWhenNotUser" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">{{ pageName }}</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">公司:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  :label="detailing?'':'请选择公司'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">申报月份:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-menu
                  v-model="showStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="form.month"
                      label="申报月份"
                      readonly
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="detailing"
                      :value="item.month&&item.month.substring(0,7)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.month"
                    locale="zh-cn"
                    type="month"
                    @input="showStartDate = false;item.month=item.month+'-01'"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>

      <!--表格-->
      <table class="xn-table">
        <thead>
          <tr>
            <th>项目</th>
            <th>行次</th>
            <th>本年累计金额(元)</th>
            <th>本月金额(元)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="big bg">一、经营活动产生的现金流量：</td>
            <td class="text-xs-center bg"></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="bg">销售产成品、商品、提供劳务收到的现金</td>
            <td class="text-xs-center bg">1</td>
            <td><CustomInput ref="form.c1" v-model="item.c1" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r1" v-model="item.r1" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">收到其他与经营活动有关的现金</td>
            <td class="text-xs-center bg">2</td>
            <td><CustomInput ref="form.c2" v-model="item.c2" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r2" v-model="item.r2" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">购买原材料、商品、接受劳务支付的现金</td>
            <td class="text-xs-center bg">3</td>
            <td><CustomInput ref="form.c3" v-model="item.c3" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r3" v-model="item.r3" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">支付的职工薪酬</td>
            <td class="text-xs-center bg">4</td>
            <td><CustomInput ref="form.c4" v-model="item.c4" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r4" v-model="item.r4" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">支付的税费</td>
            <td class="text-xs-center bg">5</td>
            <td><CustomInput ref="form.c5" v-model="item.c5" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r5" v-model="item.r5" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">支付其他与经营活动有关的现金</td>
            <td class="text-xs-center bg">6</td>
            <td><CustomInput ref="form.c6" v-model="item.c6" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r6" v-model="item.r6" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">经营活动产生的现金流量净额</td>
            <td class="text-xs-center bg">7</td>
            <td><CustomInput ref="form.c7" v-model="item.c7" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r7" v-model="item.r7" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="big bg">二、投资活动产生的现金流量：</td>
            <td class="text-xs-center bg"></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="bg">收回短期投资、长期债券投资和长期股权投资收到的现金</td>
            <td class="text-xs-center bg">8</td>
            <td><CustomInput ref="form.c8" v-model="item.c8" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r8" v-model="item.r8" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">取得投资收益收到的现金</td>
            <td class="text-xs-center bg">9</td>
            <td><CustomInput ref="form.c9" v-model="item.c9" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r9" v-model="item.r9" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">处置固定资产、无形资产和其他非流动资产收回的现金净额</td>
            <td class="text-xs-center bg">10</td>
            <td><CustomInput ref="form.c10" v-model="item.c10" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r10" v-model="item.r10" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">短期投资、长期债券投资和长期股权投资支付的现金</td>
            <td class="text-xs-center bg">11</td>
            <td><CustomInput ref="form.c11" v-model="item.c11" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r11" v-model="item.r11" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">购建固定资产、无形资产和其他非流动资产支付的现金</td>
            <td class="text-xs-center bg">12</td>
            <td><CustomInput ref="form.c12" v-model="item.c12" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r12" v-model="item.r12" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">投资活动产生的现金流量净额</td>
            <td class="text-xs-center bg">13</td>
            <td><CustomInput ref="form.c13" v-model="item.c13" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r13" v-model="item.r13" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="big bg">三、筹资活动产生的现金流量：</td>
            <td class="text-xs-center bg"></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="bg">取得借款收到的现金</td>
            <td class="text-xs-center bg">14</td>
            <td><CustomInput ref="form.c14" v-model="item.c14" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r14" v-model="item.r14" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">吸收投资者投资收到的现金</td>
            <td class="text-xs-center bg">15</td>
            <td><CustomInput ref="form.c15" v-model="item.c15" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r15" v-model="item.r15" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">偿还借款本金支付的现金</td>
            <td class="text-xs-center bg">16</td>
            <td><CustomInput ref="form.c16" v-model="item.c16" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r16" v-model="item.r16" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">偿还借款利息支付的现金</td>
            <td class="text-xs-center bg">17</td>
            <td><CustomInput ref="form.c17" v-model="item.c17" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r17" v-model="item.r17" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">分配利润支付的现金</td>
            <td class="text-xs-center bg">18</td>
            <td><CustomInput ref="form.c18" v-model="item.c18" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r18" v-model="item.r18" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">筹资活动产生的现金流量净额</td>
            <td class="text-xs-center bg">19</td>
            <td><CustomInput ref="form.c19" v-model="item.c19" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r19" v-model="item.r19" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg big">四、现金净增加额</td>
            <td class="text-xs-center bg">20</td>
            <td><CustomInput ref="form.c20" v-model="item.c20" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r20" v-model="item.r20" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg">加：期初现金余额</td>
            <td class="text-xs-center bg">21</td>
            <td><CustomInput ref="form.c21" v-model="item.c21" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r21" v-model="item.r21" :disabled="detailing"/></td>
          </tr>
          <tr>
            <td class="bg big">五、期末现金余额</td>
            <td class="text-xs-center bg">22</td>
            <td><CustomInput ref="form.c22" v-model="item.c22" :disabled="detailing"/></td>
            <td><CustomInput ref="form.r22" v-model="item.r22" :disabled="detailing"/></td>
          </tr>
        </tbody>
      </table>
      <!--表格-->
    </v-container>

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState, mapActions} from "vuex";
  import CustomInput from './CustomInput';

  export default {
    components:{
      CustomInput
    },
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
      }),
      id() {
        return this.$route.params.cashflowId;
      },
      adding() {
        return !this.id;
      },
      editing() {
        return (!!this.id) && this.$route.name === "cashflow-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "cashflow-form-detail"
      },
      deleteIdObject() {
        let arr = [];
        arr.push(this.id);
        return {cashflowIds: arr};
      },
    },
    data: () => ({
      urlName: 'cashflows',
      pageName: '现金流量表',
      rules: {
        required: value => !!value || "必填",
        isNumber: value => {
          const pattern = /^-?(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;//保留2位小数,可以为负数  ///^\d+$/
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的金额";
        },
      },
      hasErrors: false,
      item: {},
      showStartDate: false,
    }),
    methods: {
      ...mapActions(["setLoading"]),
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (this.$refs["form." + f].hasError===true) {
              this.hasErrors = true;
            }
          }
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined" &&
            this.$refs["form." + f].validate !== null &&
            typeof this.$refs["form." + f].validate !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      cancel() {
        this.$router.push({name: this.urlName});
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              this.setLoading(true);
              axios
                .post(`/${this.urlName}/delete`, this.deleteIdObject)
                .then(() => {
                  this.setLoading(false);
                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {buttonFalseText: null});
                  this.setLoading(false);
                });
            }
          }
        );
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          //去掉录入后，又不想录入 输入的空项
          for (let i in this.item) {
            if (this.item[i] === "") {
              delete this.item[i];
            }
          }
          if (this.editing) {
            //保存
            this.putEditHandler();
          } else {
            //添加
            this.postAddHandler();
          }
        }
      },
      postAddHandler() {
        this.setLoading(true);
        axios.post(`/${this.urlName}`, this.item)
          .then(() => {
            this.setLoading(false);
            this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      putEditHandler() {
        this.setLoading(true);
        axios.put(`/${this.urlName}/` + this.id, this.item)
          .then(() => {
            this.setLoading(false);
            this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      getDetailHandler() {
        this.setLoading(true);
        axios.get(`/${this.urlName}/` + this.id)
          .then(res => {
            this.item = res.data;
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
    },
    created() {
      if (this.editing || this.detailing) {
        this.getDetailHandler();
      } else {
        this.item = {
          companyId: null,
          month: null
        }
      }
    }
  }
</script>

<style scoped>

</style>
